import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

import Fr_Input from "../../../lib/ui/fr_input";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import Fr_Cal from "../../../lib/ui/fr_cal";

class Ct_Add extends React.Component {
  constructor(props, context) {
    super(props);

    ///this.pos = props.store.pos;

    this.state = {};
    this.state.mka = [];

    this.state.gnr = "001";
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];
      this.state.ctval = [
          {id: 'pdf', text: 'PDF Dokument'},
          {id: 'mp4', text: 'FILM MP4'}
      ];

    this.state.msg = {};
    this.state.cols = {};
    this.state.cto = {};
    if(props.wnds.cto) this.state.cto = props.wnds.cto;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.btn_grps();
      //if(!this.props.wnds.tdo) this.task_init();
      //this.mnu_mp();
  }

    task_init() {
        var tdo = {};
        tdo.typ = "";
        tdo.id = "";
        tdo.text = "";
        tdo.reg = "";
        tdo.status = "";
        //alert(JSON.stringify(rso));
        this.setState({ tdo: tdo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }

    wnd_close = () => {
        if(this.props.close) {
            this.props.close(this.props.ctx);
        }
        else this.props.ctx.setState({ wnds: {} });
    };
    ct_change (e) {
        const value = e.target.value;
        var cto = this.state.cto;
        cto.cttyp = value;
        this.setState({cto: cto});
    }
    anm_change (e) {
        const value = e.target.value;
        var lto = this.state.lto;
        lto.anm = value;
        this.setState({lto: lto});
    }

    val_save(id, val) {
        var cto = this.state.cto;
        cto[id] = val;
        this.setState({ cto: cto });
        return;
    }
    mnu_mp() {
        var self = this;
        var prm = {};
        prm.req = "dsi.dsi_mp.mp_mnu";
        prm.mnuid = "mn02";

        net.sio_req(prm)
            .then(function(ret){
                alert(JSON.stringify(ret.rca));

                self.setState({ mna: ret.rca });
                //self.setState({ rva: ret.rca });
                self.syncTb("mnuTable");
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
  ct_add() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_cont.ct_add";
    prm.cto = this.state.cto;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Sparad ..."} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  ct_del() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_cont.ct_del";
    prm.cto = this.state.cto;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Borttagen"} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.close) {
                      self.props.close(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "Resurs";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_90 flex-col" style={ this.dlg_style() } >
        <div className="mx_content flex">

        <div className="mx_h01">
            <div>Nytt Innehåll</div>
        </div>
            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
            <div className="flex-row">
                    <Fr_Input label="Innehålls ID" className="text-left w150" text={this.state.cto.ctid} getValue={(e)=> this.val_save("ctid", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.cto.text} getValue={(e)=> this.val_save("text", e) } />
                </div>
                <div className="flex-row hide">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.cto.text} getValue={(e)=> this.val_save("text", e) } />
                    <div className="form-group flex-row flex">
                        <span className="header">Layout Typ</span>
                        <select value={this.state.cto.cttyp} className="form-control w250" onChange={(e) => this.lt_change(e)}>
                            { this.state.ctval.map((row, key) =>
                                <option key={key} value={row.id}>{row.text}</option>
                            )}
                        </select>
                    </div>
                </div>

                <div className="divider_green"></div>
                <div className="flex-row">
                    <div className="form-group flex-row flex">
                        <span className="header">Innehålls Typ</span>
                        <select value={this.state.cto.cttyp} className="form-control w250" onChange={(e) => this.lt_change(e)}>
                            { this.state.ctval.map((row, key) =>
                                <option key={key} value={row.id}>{row.text}</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="flex-row">
                    <Fr_Input label="Url" className="text-left w350" text={this.state.cto.url} getValue={(e)=> this.val_save("url", e) } />
                </div>
                <div className="flex-row hide">
                    <Fr_Input label="Pos 1" className="text-left w150" text={this.state.cto.ct01pos} getValue={(e)=> this.val_save("ct01pos", e) } />
                    <Fr_Input label="ID 1" className="text-left w150" text={this.state.cto.ct01id} getValue={(e)=> this.val_save("ct01id", e) } />
                </div>
                <div className="flex-row hide">
                    <Fr_Input label="Radbeskrivning Storlek" className="text-left w150" text={this.state.cto.sz05} getValue={(e)=> this.val_save("sz05", e) } />
                </div>
                <div className="divider_green"></div>
                <div className="flex-row">
                     <Fr_Input label="Status" className="text-left w350" text={this.state.cto.status} getValue={(e)=> this.val_save("status", e) } />
                </div>
                <div className="flex-row hide">
                    <Fr_Input label="Bakgrundsfärg" className="text-left w250" text={this.state.cto.bgcolor} getValue={(e)=> this.val_save("bgcolor", e) } />
                </div>
                <div className="flex-row hide">
                    <Fr_Input label="Bakgrundsbild" className="text-left w350" text={this.state.cto.bgimg} getValue={(e)=> this.val_save("bgimg", e) } />
                </div>

                <div className="flex-row hide">
                    <div className="flex flex-column" style={{padding: "0px 5px"}}>
                        <span className="header">Layout information</span>
                        <textarea className="form-control" maxLength="512" rows="10" value={this.state.cto.anm} onChange={(e) => this.anm_change(e)}></textarea>
                    </div>
                </div>
            </form>

        </div>
        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250" onClick={() => this.ct_add() } >
                SPARA
            </button>
        </div>
      </div>

        <Wnd_Error msg={this.state.msg} ctx={this} />
        <Wnd_Ok msg={this.state.msg} ctx={this} />
        <Wnd_Info msg={this.state.msg} ctx={this} />
        <Wnd_Confirm msg={this.state.msg} ctx={this} />
      </div>
	;
	return html;
  };
}

export default Ct_Add;